import React from "react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const Timeline = () => {
  const { t } = useLang();
  return (
    <section className="bg-white py-28 md:py-36 border-t border-black/5" data-testid="home-timeline">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <Reveal className="mb-16">
          <p className="eyebrow-dark">{t.timeline.eyebrow}</p>
          <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-[#061A26]">{t.timeline.title}</h2>
        </Reveal>
        <div className="relative">
          <div className="absolute left-[19px] md:left-1/2 top-2 bottom-2 w-px bg-black/8" aria-hidden="true" />
          {t.timeline.steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} y={24}>
              <div
                className={`relative flex gap-8 md:gap-0 pb-14 last:pb-0 md:items-start ${
                  i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                }`}
                data-testid={`timeline-step-${i}`}
              >
                <div className="absolute left-[11px] md:left-1/2 md:-translate-x-1/2 mt-1 w-4 h-4 rounded-full border-2 border-[#19C7C1] bg-white z-10" aria-hidden="true" />
                <div className={`ml-12 md:ml-0 md:w-1/2 ${i % 2 === 0 ? "md:pr-16 md:text-right" : "md:pl-16"}`}>
                  <span className="text-xs font-semibold tracking-[0.3em] text-[#19C7C1] tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-2 text-lg md:text-xl font-semibold text-[#061A26]">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
                <div className="hidden md:block md:w-1/2" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
